'use client';
import { Card, CardContent, CardActionArea, Box, Typography, CardMedia } from '@mui/material';
import React from 'react';
import { DEFAULT_DAPP_STATE } from '../../utils';

const TokenCard = ({ token, onClick }) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease-in-out',
        background: 'rgba(19, 19, 26, 0.8)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
        '&:hover': {
          transform: 'translateY(-8px) scale(1.02)',
          boxShadow: `0 0 25px ${token.glowColor}`,
          border: `1px solid ${token.color}`,
        },
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <CardActionArea
        disabled={!DEFAULT_DAPP_STATE[token.name]}
        onClick={onClick}
        sx={{ flexGrow: 1 }}
      >
        <Box
          sx={{
            height: 160,
            background: `linear-gradient(135deg, rgba(19, 19, 26, 0.8) 0%, ${token.color}40 100%)`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            overflow: 'hidden',
            padding: 3,
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `radial-gradient(circle at center, ${token.color}40 0%, transparent 70%)`,
              opacity: 0.5,
              transition: 'opacity 0.3s ease-in-out',
            },
            '&:hover::before': {
              opacity: 1,
            },
          }}
        >
          <CardMedia
            component="img"
            image={token.image}
            alt={token.name}
            style={{ padding: '5px' }}
            sx={{
              width: '70%',
              height: 'auto',
              objectFit: 'contain',
              filter: `drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3)) drop-shadow(0px 0px 10px ${token.glowColor})`,
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                filter: `drop-shadow(0px 0px 20px ${token.color})`,
                transform: 'scale(1.05)',
              },
            }}
          />
        </Box>
        <CardContent>
          <Typography variant="h6" component="div" gutterBottom sx={{ color: token.color }}>
            {token.name}{' '}
            <Typography variant="body2" component="span" color="text.secondary">
              ({DEFAULT_DAPP_STATE[token.name] ? token.symbol : 'Coming Soon'})
            </Typography>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {token.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default TokenCard;
